(async () => {
	const debugMode = 1,
		testId = "GLX-026",
		logInfo = testId + " -->",
		variation = 1;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			_window._conv_q = _window._conv_q || [];

			// Wait for the main content wrapper
			const waitForElement = (selector) => {
				try {
					return new Promise((resolve) => {
						try {
							if (document.querySelector(selector)) {
								resolve(document.querySelector(selector));
								return;
							}

							const observer = new MutationObserver(() => {
								try {
									if (document.querySelector(selector)) {
										observer.disconnect();
										resolve(document.querySelector(selector));
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});

							observer.observe(document.documentElement, {
								childList: true,
								subtree: true
							});
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Wait for an element(s) to be fully loaded in the DOM
			const sentConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const sendGAEvent = (category) => {
				try {
					let _category = `hd_${category.toLowerCase().trim().replace(/ /gi, "_")}`;

					_window.gtag("event", _category, {
						send_to: "G-2FT1FSRP5J"
					});

					if (debugMode) console.log(logInfo, "Sent GA event:", _category);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement("header-sidebar .header-sidebar__main-panel .header-sidebar__footer").then((headerSidebarFooter) => {
				try {
					headerSidebarFooter.insertAdjacentHTML(
						"afterbegin",
						`
						<a href="https://galxboy.co.za/pages/stores" class="text-with-icon smallcaps sm:hidden ${testId}_find-store-link">
							<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M15 7.45455C15 12.8636 8 17.5 8 17.5C8 17.5 1 12.8636 1 7.45455C1 5.61008 1.7375 3.84117 3.05025 2.53694C4.36301 1.23271 6.14348 0.5 8 0.5C9.85652 0.5 11.637 1.23271 12.9497 2.53694C14.2625 3.84117 15 5.61008 15 7.45455Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M8.00033 9.77272C9.28899 9.77272 10.3337 8.73483 10.3337 7.45453C10.3337 6.17424 9.28899 5.13635 8.00033 5.13635C6.71166 5.13635 5.66699 6.17424 5.66699 7.45453C5.66699 8.73483 6.71166 9.77272 8.00033 9.77272Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							FIND A STORE NEAR YOU
						</a>
					`
					);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();